const initialState = {
  contact: null,
  isLoading: null,
  isError: null,
};

export default initialState;
